import { Route, Routes, useLocation } from "react-router-dom";

import Nav from "./components/Nav/Nav";
import Footer from "./components/Footer/Footer";
import NotFound from "./pages/NotFound/NotFound";
import UnsubscribeMarketing from "./pages/UnsubscribeMarketing/UnsubscribeMarketing";
import { Documents } from "./pages/Documents/Documents";
import Support from "./pages/Support/Support";
import { useEffect, useRef } from "react";
import { toggleScrolling } from "../assets/Utils/generic";
import getLink, { LINK_TYPE } from "../config/Links";
import { InnovativeStartup } from "./pages/InnovativeStartup/InnovativeStartup";
import { ProfileRoutes } from "./pages/Profile/ProfileRoutes";
import { Retrieve } from "./components/Auth/AuthComponents";
import RequiresAuth from "./hoc/RequiresAuth";
import { useSelector } from "react-redux";
import { selectUser } from "../redux/slices/userSlice";
import { fireTagManagerEvent } from "../assets/Services/tagmanager";
import Results from "./pages/Directsearch/Results";
import SecondaryMarket from "./pages/SecondaryMarket/SecondaryMarket";
import { useAppDispatch } from "../redux/redux";
import { setHeroVisibility } from "../redux/slices/appSlice";
import { Path } from "../config/paths";
import Home from "./pages/Directsearch/Home";

import DetailPage from "./pages/DetailPage/DetailPage";
import RedirectIg from "./pages/RedirectIg";

export const PROMO_AUTH_KEY =
  "vwb7n58796mm6n86b745v" + process.env.REACT_APP_FRONTEND_URI;

function scrollToTop() {
  window.scrollTo({ top: 0 });
}

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    scrollToTop();
    toggleScrolling(true);
    setTimeout(() => {
      scrollToTop();
    }, 5);
  }, [pathname]);

  return <></>;
}

function WebRouter() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} key="metasearch-home-route" />
        <Route path="/ig" element={<RedirectIg />} key="ig" />
        <Route
          path={Path.DIRECTSEARCH_RESULTS}
          element={<Results />}
          key="directsearch-results-route"
        />
        {/* <Route path="/directsearch/redirect" element={<MetasearchRedirect />} /> */}
        <Route
          path="/secondary_market"
          element={<SecondaryMarket />}
          key="secondary-market-route"
        />
        <Route path="/retrieve" element={<Retrieve />} key="retrieve-route" />
        <Route
          path="/profile/*"
          element={
            <RequiresAuth>
              <ProfileRoutes />
            </RequiresAuth>
          }
          key="profile-routes"
        />
        <Route
          path="/innovative_startup"
          element={<InnovativeStartup />}
          key="innovative-startup-route"
        />
        <Route
          path="/tos"
          element={<Documents name="Terms of Service" />}
          key="tos-route"
        />
        <Route
          path="/terms-conditions"
          element={<Documents name="Terms of Service" />}
          key="terms-conditions-route"
        />
        <Route
          path="/privacy"
          element={<Documents name="Privacy Policy" />}
          key="privacy-route"
        />
        <Route
          path="/cookies"
          element={<Documents name="Cookie Policy" />}
          key="cookies-route"
        />
        <Route path="/support" element={<Support />} key="support-route" />
        <Route
          path="/unsubscribe"
          element={<UnsubscribeMarketing />}
          key="unsubscribe-route"
        />
        <Route
          path="/:hotel"
          element={<DetailPage />}
          key="detail-page-route"
        />
        <Route path="*" element={<NotFound />} key="not-found-route" />
      </Routes>
    </>
  );
}

export default function Web() {
  const { pathname } = useLocation();

  const user = useSelector(selectUser);
  const dispatch = useAppDispatch();

  const isScrollHandled = useRef(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY === 0) {
        dispatch(setHeroVisibility(true));
      } else {
        dispatch(setHeroVisibility(false));
      }

      if (!isScrollHandled.current) {
        setTimerScroll();
        isScrollHandled.current = true;
      }
    };

    const setTimerScroll = () => {
      window.setTimeout(() => {
        fireTagManagerEvent("scroll_land");
      }, 5000);
    };

    window.addEventListener("scroll", handleScroll);

    if (user || localStorage.getItem(PROMO_AUTH_KEY)) return;

    // setTimeout(() => {
    //   openAuthModal(AUTH_SECTION.register_promo);

    //   localStorage.setItem(PROMO_AUTH_KEY, "true");
    // }, 60 * 1000);
  }, []);

  return (
    <>
      <div
        className={`${
          pathname.includes(getLink(LINK_TYPE.PROFILE))
            ? "white-background"
            : "black-background"
        } h100 w100`}
      >
        <Nav />
        <div
          style={{
            height: pathname.includes(getLink(LINK_TYPE.PROFILE))
              ? "calc(100dvh - 75px)"
              : "",
          }}
        >
          <WebRouter />
          <ScrollToTop />
        </div>
        <Footer />
      </div>
    </>
  );
}
